import { createApi } from '@reduxjs/toolkit/query/react';
import {
  axiosBaseQuery,
  getBaseQuery,
  handleSessionExpiredError,
} from '../../utils/auth';
import { Commune, FormRequest } from '../../types/registrationTypes';
import { Account, User } from '../../types/auth';

// Define a service using a base URL and expected endpoints
export const accountApi = createApi({
  reducerPath: 'accountApi',
  baseQuery: getBaseQuery('/manage-account'),
  endpoints: (builder) => ({
    getRegistrationFormData: builder.query<FormRequest, void>({
      query: () => ({
        url: `/registration-form-data`,
      }),
      transformErrorResponse: (response) => handleSessionExpiredError(response),
    }),
    getComunnes: builder.query<Commune[], string | number | null | undefined>({
      query: (regionId) => ({
        url: `/registration-form-data/regions/${regionId}/communes`,
      }),
      transformErrorResponse: (response) => handleSessionExpiredError(response),
    }),
    getProfile: builder.query<User, void>({
      query: () => ({
        url: `/users/profile`,
      }),
      transformErrorResponse: (response) => handleSessionExpiredError(response),
    }),
    updateProfile: builder.mutation<Account, any>({
      query: (body) => ({
        url: `/users`,
        method: 'PUT',
        body,
      }),
      transformErrorResponse: (response) => handleSessionExpiredError(response),
    }),
    updatePassword: builder.mutation<
      void,
      { oldPassword: string; newPassword: string }
    >({
      query: (body) => ({
        url: `/users/password`,
        method: 'PUT',
        body,
      }),
      transformErrorResponse: (response) => handleSessionExpiredError(response),
    }),
  }),
});

export const fileApi = createApi({
  reducerPath: 'fileApi',
  baseQuery: axiosBaseQuery('/manage-account'),
  endpoints: (builder) => ({
    updateFile: builder.mutation<
      void,
      { file: File; name: 'curriculum' | 'additionalFile' }
    >({
      query: ({ file, name }) => {
        const body = new FormData();
        body.append(name, file, file.name);
        return {
          url: `/users/file-upload`,
          method: 'POST',
          body,
        };
      },
      transformErrorResponse: (response) => handleSessionExpiredError(response),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetRegistrationFormDataQuery,
  useGetComunnesQuery,
  useGetProfileQuery,
  useUpdateProfileMutation,
  useUpdateFileMutation,
  useUpdatePasswordMutation,
} = { ...accountApi, ...fileApi };
